import { ReactElement } from "react";
import { useState } from "react";
import { ParameterValue } from "calculation/parameter";
import { useEffect } from "react";
import { ParameterDefaultValueDto, ParameterOptionDto } from "dtos/dtos";

export function ParameterSelect(props: {
  options: ParameterOptionDto[] | undefined;
  parameterValue: ParameterValue;
  parameterDefaultValue: ParameterDefaultValueDto | undefined;
  disabled: boolean;
  onChange: () => void
}): ReactElement {
  const { disabled, options, parameterDefaultValue, parameterValue, onChange } = props;
  function handleChange(e: any) {
    const option = options?.find((o) => o.id === parseInt(e.target.value));

    if (option !== undefined) {
      parameterValue.value = option.value;
      parameterValue.displayValue = option.displayValue;
      setSelectedOptionValue(option.id);
    }

    onChange();
  }
  const [selectedOptionValue, setSelectedOptionValue] = useState<number>();

  useEffect(() => {
    let option: ParameterOptionDto | undefined;

    option = options?.find(
      (o) =>
        o.value === parameterValue.value &&
        o.displayValue === parameterValue.displayValue
    );

    if (option === undefined) {
      option = options?.find((o) => o.value === parameterValue.value);

      if (option === undefined) {
        setSelectedOptionValue(-1);
      } else {
        setSelectedOptionValue(option.id);
      }
    } else {
      setSelectedOptionValue(option.id);
    }
  }, [parameterValue, options]);

  if (options !== undefined) {
    const optionElements = options.map((o) => (
      <option
        key={o.id}
        value={o.id}
        className={
          o.value === parameterDefaultValue?.value &&
          o.displayValue === parameterDefaultValue?.displayValue
            ? "text-gray-600 font-bold"
            : "text-gray-600"
        }
      >
        {o.displayValue}
      </option>
    ));

    const valueMatches = options.filter(
      (o) => o.value === parameterValue.value
    );
    const displayValueMatch = options.find(
      (o) => o.displayValue === parameterValue.displayValue
    );

    if (valueMatches.length === 0 || displayValueMatch === undefined) {
      options.push({
        id: -1,
        value: parameterValue.value,
        displayValue: `${
          parameterValue.displayValue
        } (${parameterValue.value.toString()})`,
        dichteKat: null,
      });

      optionElements.push(
        <option key={-1} value={-1} className="text-gray-600">
          {`${
            parameterValue.displayValue
          } (${parameterValue.value.toString()})`}
        </option>
      );
    }

    return (
      <select
        value={selectedOptionValue}
        onChange={handleChange}
        disabled={disabled}
        className={`w-[500px] py-1 border-2 border-gray-200 focus:border-blue-400 focus:ring-0 ${
          disabled
            ? "text-gray-400 border-gray-200"
            : parameterDefaultValue?.value === parameterValue.value &&
              parameterDefaultValue?.displayValue ===
                parameterValue.displayValue
            ? "text-gray-600 border-gray-300"
            : "text-orange-300 border-gray-300"
        }`}
      >
        {optionElements}
      </select>
    );
  }

  return <></>;
}
